import React, {useState, useEffect, useRef} from 'react';

const EditorFile = ({articleId, file, setFiles, isAdminArticlePage}) => {
  const triggerRef = useRef(null);

  useEffect(() => {
    if (!isAdminArticlePage && file.description) {
      $(document).foundation('reflow');
    }
  }, []);

  const deleteFile = () => {
    $.ajax({
      type: "DELETE",
      url: `/publish/articles/${articleId}/editor_review_files/${file.id}`,
      dataType: 'json',
      success: function(res) {
        // clears tooltip lingering problem
        const $el = $(triggerRef.current);
        try { $el.trigger('mouseleave'); } catch (e) {}
        const id = $el.attr('aria-describedby');
        if (id) { $(`#${id}`).remove(); $el.removeAttr('aria-describedby'); }

        setFiles(res.content_files);

        setTimeout(() => { $(document).foundation('reflow'); }, 0);
      }
    });
  };
  
  const ellipsFilename = (name, { head = 8, tail = 8 }) => {
    if (!name) return "";
    const dot = name.lastIndexOf(".");
    const base = dot > 0 ? name.slice(0, dot) : name;
    const ext  = dot > 0 ? name.slice(dot) : "";
    if (base.length <= head + tail) return name;

    return `${base.slice(0, head)}…${base.slice(-tail)}${ext}`;
  };

  const handleDownload = () => {
    if (!isAdminArticlePage) return;
    window.location.href = file.download_url;
  };

  const display = ellipsFilename(file.file_name, { head: 4, tail: 4 });
  const tooltipProps = !isAdminArticlePage && file.description ? { "data-tooltip": "", title: file.description } : {};

  return (
    <div className="file-container-wrap">
      <div ref={triggerRef} className={"file-container tip-top " + (isAdminArticlePage ? "admin-page" : "")} {...tooltipProps} onClick={handleDownload}>
        { !isAdminArticlePage && <img className="close-icon" src="https://public.cureus.com/channel_design/delete_widget.png" onClick={(e) => { e.stopPropagation(); deleteFile() }} /> }
        <div className="file-info">
          <img src="https://public.cureus.com/doc_icon.png" />
          <p className="filename">{display}</p>
        </div>
      </div>
      { isAdminArticlePage && <p className="file-description">{file.description}</p> }
    </div>
  )
};

export default EditorFile;